import { Base } from '@studiometa/js-toolkit';

/**
 * DarkModeInput component
 */
export default class DarkModeInput extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'DarkModeInput',
  };

  /**
   * isDarkMode
   * @returns {string}
   */
  get isDarkMode() {
    return localStorage.getItem('darkmode') === '1';
  }

  /**
   *
   */
  mounted() {
    if (this.isDarkMode) {
      this.$el.checked = true;
    }
  }

  /**
   * onChange
   */
  onChange() {
    if (this.$el.checked && localStorage.getItem('dark') !== '1') {
      document.scrollingElement.classList.add('dark');
      localStorage.setItem('darkmode', '1');
    } else {
      document.scrollingElement.classList.remove('dark');
      localStorage.setItem('darkmode', '0');
    }
  }
}
